<div class="flex flex-col">
  <!-- TODO PROTRACTOR: Leaving class page-header so protractor tests dont break -->
  <mat-tab-group
    dynamicHeight
    [selectedIndex]="activeTab"
    (selectedTabChange)="onTabChange($event.index)"
  >
    <mat-tab label="My Content">
      <ng-template matTabContent>
        <app-content-table
          [contentTableType]="contentTableType.MyContent"
        ></app-content-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="My Edition's Content">
      <ng-template matTabContent>
        <app-content-table
          [contentTableType]="contentTableType.TeamContent"
          [disableWebsiteFilter]="true"
        ></app-content-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="All Content">
      <ng-template matTabContent>
        <app-content-table
          [contentTableType]="contentTableType.AllContent"
        ></app-content-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="Columnist's Content">
      <ng-template matTabContent>
        <app-content-table
          [contentTableType]="contentTableType.ColumnistContent"
        ></app-content-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="Sub-editor's Content" *ngIf="canSubEdit$ | async">
      <ng-template matTabContent>
        <app-content-table
          [contentTableType]="contentTableType.SubEditorContent"
          [disableStatusFilter]="true"
        ></app-content-table>
      </ng-template>
    </mat-tab>
    <mat-tab disabled>
      <ng-template mat-tab-label *ngIf="canWriteArticles$ | async">
        <a
          [routerLink]="[
            '/content',
            CONTENT_TYPE_ROUTER_PATH[contentTypes.ARTICLE],
            'new'
          ]"
          class="text-white no-underline"
        >
          <div
            class="px-2 pr-2 leading-9 opacity-100 bg-project-2100 hover:bg-project-2100 hover:opacity-80"
          >
            Create Article
          </div>
        </a>
        <div
          class="leading-9 bg-project-2100 hover:text-white hover:bg-project-2100 hover:opacity-80"
        >
          <mat-select class="px-1">
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.ARTICLE],
                'new'
              ]"
              ><mat-option class="px-3">Article</mat-option></a
            >
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.GALLERY],
                'new'
              ]"
              ><mat-option class="px-3">Gallery</mat-option></a
            >
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.PAGE],
                'new'
              ]"
              ><mat-option class="px-3">Page</mat-option></a
            >
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.DIGITAL_PUBLICATION],
                'new'
              ]"
              ><mat-option class="px-3">Digital Publication</mat-option></a
            >
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.SINGLE_SPONSOR],
                'new'
              ]"
              *ngIf="isSingleSponsorFeatureEnabled$ | async"
              ><mat-option class="px-3">Single Sponsor</mat-option></a
            >
            <a
              [routerLink]="[
                '/content',
                CONTENT_TYPE_ROUTER_PATH[contentTypes.CONTENT_SET],
                'new'
              ]"
              *ngIf="isContentSetFeatureEnabled$ | async"
              ><mat-option class="px-3">Content Set</mat-option></a
            >
          </mat-select>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
